import { render, staticRenderFns } from "./DefaultOtro.vue?vue&type=template&id=2e1c7dce&"
import script from "./DefaultOtro.vue?vue&type=script&lang=js&"
export * from "./DefaultOtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports